var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52994 5.93469L7.94894 0.534689C7.97449 0.493017 7.99069 0.446299 7.99644 0.397757C8.00218 0.349216 7.99733 0.300005 7.98221 0.25352C7.9671 0.207036 7.94208 0.164383 7.90889 0.128502C7.87569 0.0926218 7.83511 0.0643683 7.78994 0.0456891C7.72757 0.0156708 7.65916 0.000279933 7.58994 0.000689065L0.409942 0.000689693C0.307909 -0.00562171 0.207525 0.0286944 0.130707 0.0961439C0.0538888 0.163594 0.00687882 0.258698 -5.82009e-05 0.360689C0.000168779 0.428029 0.0211167 0.493668 0.0599413 0.54869L3.82094 5.94869C3.88538 6.03214 3.9774 6.08994 4.08055 6.11174C4.18371 6.13354 4.29125 6.11793 4.38394 6.06769C4.44332 6.03677 4.49363 5.99093 4.52994 5.93469Z",
    fill: "#C5C4CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrow);
export default __webpack_public_path__ + "static/media/sort-arrow.84b1bfc3c81ada85b7263581d8b8f727.svg";
export { ForwardRef as ReactComponent };